import { RangeFilterValueType } from './RangeFilter';

export class RangeFilterValue implements RangeFilterValueType {
    public static empty(): RangeFilterValue {
        return new RangeFilterValue(0, Infinity);
    }

    public readonly min: number;

    public readonly max: number;

    constructor(min: number, max: number) {
        if (min > max) {
            this.min = max;
            this.max = min;
        } else {
            this.min = min;
            this.max = max;
        }
    }
}
